import React from 'react';
import { Dropdown, Menu, MenuButton, MenuItem, Sheet, Typography } from '@mui/joy';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';

const Header = () => {
    const navigate = useNavigate();
    const { userId, signOut } = useAuth();

    const handleSignOut = async () => {
        await signOut();
        navigate('/');
    };

    return (
        <Sheet
            component="header"
            variant="solid"
            color="primary"
            sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <Typography level="h1" textColor="inherit" sx={{ flexGrow: 1 }}>
                Disk Golf Score Keeper
            </Typography>
            <Dropdown>
                <MenuButton variant="solid" color="primary" size="lg">
                    <MenuIcon />
                </MenuButton>
                <Menu>
                    <MenuItem onClick={() => navigate('/')}>Home</MenuItem>
                    {userId ? (
                        <>
                            <MenuItem onClick={() => navigate('/account')}>Account</MenuItem>
                            <MenuItem onClick={handleSignOut}>Log Out</MenuItem>
                        </>
                    ) : (
                        <MenuItem onClick={() => navigate('/login')}>Log In</MenuItem>
                    )}
                </Menu>
            </Dropdown>
        </Sheet>
    );
};

export default Header;
